export * from './actividad';
export * from './agenda';
export * from './colaboradores';
export * from './common';
export * from './configuracion';
export * from './cuentas';
export * from './dashboard';
export * from './negocios';
export * from './login';
export * from './buscador';
export * from './abm';
export * from './perfil';
export * from './agris';
export * from './administracion';
export * from './comunicaciones';
export * from './precios-seccion';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/index.ts